import { Typography } from '@prenuvo/halo';

import { PatientDocLink } from '../../patient-docs-side-panel.model';
import { usePatientDocs } from '../use-patient-docs.hook';
import { DocumentActions } from './document-actions.component';
import { DocumentRowContainer } from './document-row-container.component';

interface MedicalHistorySummaryRowProps {
  mhsLink: PatientDocLink;
}

export function MedicalHistorySummaryRow({ mhsLink }: MedicalHistorySummaryRowProps) {
  const { onUpdatePatientDocument } = usePatientDocs();

  const handleOpenDocument = () => onUpdatePatientDocument({ link: mhsLink, name: 'MHS' });

  return (
    <DocumentRowContainer>
      <Typography
        translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.MEDICAL_HISTORY_SUMMARY"
        variant="paragraph-sm"
      />

      <DocumentActions link={mhsLink} onOpenDocument={handleOpenDocument} />
    </DocumentRowContainer>
  );
}
